<template>
  <el-container style="width: 100%; height: 100%;">
    <lx-navigator nav-title="汽车维修培训"
                  :nav-active="navActive"
                  :menuItems="menuItems"></lx-navigator>

    <el-main style="padding: 0 10px; height: 100%; ">
      <el-row class="lx-right-title">
        <el-col>{{ title }}</el-col>
      </el-row>
      <el-row class="lx-right-sub-title">
        <el-col :span="20"><i></i>实训记录统计</el-col>
        <el-col :span="4" style="text-align: right;">
          <el-button type="primary" size="mini" @click="setTraining">实训设置</el-button>
        </el-col>
      </el-row>
      <el-row style="height: calc(100% - 160px); background: #fff; padding: 10px;">
        <el-col :span="24">
          <el-tabs type="card"
                   v-model="activeTab"
                   @tab-click="changeTab"
                   class="lx-tabs-custom">
            <el-tab-pane v-for="(list, index) in classList"
                          :label="list.name"
                          :name="list.value.toString()"
                          :key="index"
                          lazy>
              <el-table class="lx-table lx-class-table lx-tag-box"
                        size="medium"
                        border
                        row-class-name="lx-table-row"
                        header-cell-class-name="lx-table-header-cell"
                        cell-class-name="lx-table-cell"
                        :data="trainingData.rows">
                <el-table-column prop="lexueId"
                                  align="center"
                                  label="乐学号">
                </el-table-column>
                <el-table-column prop="name"
                                  align="center"
                                  label="姓名">
                </el-table-column>
                <el-table-column prop="times"
                                  align="center"
                                  label="实训次数">
                </el-table-column>
                <el-table-column prop="lastedTime"
                                  align="center"
                                  label="最新实训时间">
                  <template slot-scope="scope">
                    <span v-if="scope.row.times === 0">-</span>
                    <span v-else>{{ timeTrans(scope.row.lastedTime) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      <el-row class="lx-pagination-row">
        <el-col :span="24">
          <el-pagination :total="trainingData.total"
                          :page-size="trainingData.size"
                          :current-page.sync="trainingData.page"
                          background
                          layout="total, prev, pager, next"
                          @current-change="handleCurrentChange"></el-pagination>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import Navigator from '@/components/common/Navigator'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')
export default {
  props: ['displayType', 'nav-active'],

  data () {
    return {
      menuItems: [
        { index: '1-1', name: '', value: null, route: { name: 'EngineTrainingRecord' } },
        { index: '1-2', name: '', value: null, route: { name: 'CylinderTrainingRecord' } },
        { index: '1-3', name: '', value: null, route: { name: 'CrankshaftTrainingRecord' } },
        { index: '1-4', name: '', value: null, route: { name: 'SynchronizeTrainingRecord' } }
      ],
      classList: [],
      activeTab: '',
      title: '',
      trainingData: {},
      pagesize: 15,
      currentpage: 1
    }
  },

  components: { 'lx-navigator': Navigator },

  watch: {
    menuItems: {
      handler: function (newVal, oldVal) {
        this.$nextTick(function () {
          if (newVal[3].name) {
            this.initData()
          }
        })
      },
      deep: true
    },
    classList: {
      handler (newVal, oldVal) {
        this.$nextTick(function () {
          if (this.classList[0]) {
            this.activeTab = this.classList[0].value.toString()
            this.getTrainingData()
          }
        })
      },
      deep: true
    }
  },

  mounted () {
    this.getMenu()
    this.getClassData()
  },

  methods: {
    initData () {
      switch (this.displayType) {
        case '发动机':
          this.apiIdentity = this.menuItems[0].value
          this.title = this.menuItems[0].name
          break
        case '气缸':
          this.apiIdentity = this.menuItems[1].value
          this.title = this.menuItems[1].name
          break
        case '曲轴':
          this.apiIdentity = this.menuItems[2].value
          this.title = this.menuItems[2].name
          break
        case '变速器同步器':
          this.apiIdentity = this.menuItems[3].value
          this.title = this.menuItems[3].name
          break
      }
    },
    getClassData () {
      this.$xhrGet(`/train/classes`)
        .then(rs => {
          this.classList = rs.data
        })
    },
    getTrainingData () {
      let pageParam = { page: this.currentpage, size: this.pagesize, classId: this.activeTab }
      this.$xhrGet(`/train/items/${this.apiIdentity}`, pageParam)
        .then(rs => {
          this.trainingData = rs.data
        })
    },
    changeTab (tab) {
      this.currentpage = 1
      let pageParam = { page: this.currentpage, size: this.pagesize, classId: this.activeTab }
      this.$xhrGet(`/train/items/${this.apiIdentity}`, pageParam)
        .then(rs => {
          this.trainingData = rs.data
        })
    },
    handleCurrentChange (page) {
      this.currentpage = page
      this.getTrainingData()
    },
    getMenu () {
      this.$xhrGet(`/projects`)
        .then(rs => {
          for (var i = 0, len = rs.data.length; i < len; i++) {
            this.menuItems[i].name = rs.data[i].name
            this.menuItems[i].value = rs.data[i].value
          }
        })
    },
    timeTrans (id) {
      let idDate = new Date(id)
      return moment(idDate.getTime()).format(('YYYY-MM-DD HH:mm'))
    },
    setTraining () {
      sessionStorage.setItem('menu', JSON.stringify(this.menuItems))
      switch (this.displayType) {
        case '发动机':
          this.$router.push({ name: 'EngineTrainingSetting' })
          break
        case '气缸':
          this.$router.push({ name: 'CylinderTrainingSetting' })
          break
        case '曲轴':
          this.$router.push({ name: 'CrankshaftTrainingSetting' })
          break
        case '变速器同步器':
          this.$router.push({ name: 'SynchronizeTrainingSetting' })
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/training/TrainingRecord.vue